export { default } from "./useThemeProps.js";
export { default as getThemeProps } from "./getThemeProps.js";